import { render } from "./ProjectSectionInfo.vue?vue&type=template&id=5189122a&scoped=true"
import script from "./ProjectSectionInfo.vue?vue&type=script&lang=js"
export * from "./ProjectSectionInfo.vue?vue&type=script&lang=js"

import "./ProjectSectionInfo.vue?vue&type=style&index=0&id=5189122a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5189122a"]])

export default __exports__